/**
 * Day stamps — §13.1.
 *
 * `readOn` is a DAY, not an instant: "was this page already read today" must not churn
 * the store on every page turn, and a stamp makes that a single integer comparison.
 *
 * Integer and timezone-free. These two lines are all that survives of the SM-2 module
 * this app does not have — they are here, rather than inlined in the store, because
 * §4.2 keeps every pure function in this package.
 */
import { DAY_MS } from './constants'

export const dayStamp = (nowMs: number): number => Math.floor(nowMs / DAY_MS)

export const dayStampToMs = (day: number): number => day * DAY_MS
